/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoAuthTelegramOptions interface.
 */
export function instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoAuthTelegramOptions(value) {
    if (!('InitData' in value) || value['InitData'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoAuthTelegramOptionsFromJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoAuthTelegramOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoAuthTelegramOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'InitData': json['InitData'],
    };
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoAuthTelegramOptionsToJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoAuthTelegramOptionsToJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoAuthTelegramOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'InitData': value['InitData'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoAuthTelegramOptions.js.map